<template>
  <div class="relative mt-24">
    <p class="text-green font-bold w-fit m-4 mx-auto text-2xl">Votre demande de désinscription a bien été prise en compte !</p>
  </div>
</template>

<script>
export default {
  name: 'UnsubView'
}
</script>

<style scoped></style>
